var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"toast-wrapper",style:(_vm.wrapperStyle)},[_c('transition',{attrs:{"name":"fade"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }